module.exports = __webpack_public_path__ + "static/media/ivf screenshot.4eaae9ab.png";